import React, { useState, useEffect } from "react";
import Services from "../../utils/services";
import ApiServices from "../../utils/apiServices";
import { useHistory } from "react-router";
import "../../components/GenAIResult/Header.css"
import { imsLoader, JJ_Guide, JJ_Help, JJ_Home, JJ_IM_Logo, mainMenuCollMobile, mainMenuExpMobile, JJ_IMedical_icon } from "../../assets";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import SearchAskQuestionIndex from "../../components/GenAIResult/SearchAskQuestionIndex";
import GenAINavigationMenu from "../Navigation/GenAINavigationMenu";
import GenAIGlobalMyLinks from "../header/GenAIGlobalMyLinks";
import GenAIMyAvatar from "../header/GenAIMyAvatar";
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

export default function Header(props) {
    const [userExists, setUserExists] = useState(false);
    const [funcLoaded, setFuncLoaded] = useState(false);
    const [customWidth, setCustomWidth] = useState(props.customWidth);
    const [customHeight, setCustomHeight] = useState(props.customHeight);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [displayMainMenu, setMainMenuDisplay] = useState(false);
    const [initials, setInitials] = useState("");
    const [dropdownValue, setDropdownValue] = useState(props.dropdownValue);
    const [fieldedValue, setFieldedValue] = useState(props.fieldedValue);

    const [isDisableAIOverview, setIsDisableAIOverview] = useState(props.isDisableAIOverview);
    const [isDisableAIOverviewProcessing, setIsDisableAIOverviewProcessing] = useState(props.isDisableAIOverviewProcessing);

    useEffect(() => {
        setDropdownValue(props.dropdownValue)
    }, [props.dropdownValue]);


    useEffect(() => {
        setIsDisableAIOverview(props.isDisableAIOverview)
    }, [props.isDisableAIOverview]);

    useEffect(() => {
        setIsDisableAIOverviewProcessing(props.isDisableAIOverviewProcessing)
    }, [props.isDisableAIOverviewProcessing]);


    useEffect(() => {
        setFieldedValue(props.fieldedValue)
    }, [props.fieldedValue]);

    useEffect(() => {
        setSearchKeyword(props.searchKeyword)
    }, [props.searchKeyword])
    let userid = '';
    const history = useHistory();
    useEffect(async () => {
        try {
            // document.title = 'iMedical Search';
            window.scrollTo(0, 0);

            userid = JSON.parse(localStorage.getItem('username'));
            let wwid = JSON.parse(localStorage.getItem('wwid'));
            let userExists = localStorage.getItem('userExists');
            let service = new Services();
            let apiService = new ApiServices();
            service.logService(`Gen Ai Home page successfully mounted for ${userid.toLowerCase()}`, 'info');
            if (userExists) {
                setUserExists(userExists);

                let approvedState = await apiService.getUserStatus(wwid);
                let apiRes = await apiService.getUserApprovedRegionRole(wwid);
                if (approvedState.status === 'Accepted') {
                    localStorage.setItem('region', approvedState.regions);
                    localStorage.setItem('function', JSON.stringify(approvedState.profession));
                    setFuncLoaded(true);
                }
                else {
                    if (apiRes) {
                        localStorage.setItem('region', apiRes.region);
                        localStorage.setItem('function', JSON.stringify(apiRes.function));
                    }
                    else {
                        localStorage.setItem('region', approvedState.regions);
                        localStorage.setItem('function', JSON.stringify('Commercial'));
                    }
                    setFuncLoaded(true);
                }

                /*Get the localStorage values to getAllFilters POST Call*/
                /* if(localStorage.getItem('contentpreference') == null){ */
                let res = await apiService.getUserPreferenceFromUserDetails(wwid);
                localStorage.setItem('contentpreference', JSON.stringify(res?.contentprefernce));
                /* localStorage.setItem('region',res.regions); */
                localStorage.setItem('userproducts', res.products);
                localStorage.setItem('doctypepref', res.docs);

            } else {
                console.log('Access Denied');
                history.push('/');
            }
            localStorage.removeItem('selectedResults')
            localStorage.removeItem('ItemsPerPage')
            localStorage.removeItem('ActivePage')
            localStorage.removeItem('markedResultsUrl')
            sessionStorage.clear();
        } catch (error) {

        }

    }, []);

    useEffect(() => {
        const updateDimensions = () => {
            // setCustomWidth(window.innerWidth);
            // setCustomHeight(window.innerHeight)
        }
        // Add event listener
        // window.addEventListener('resize', updateDimensions);
        // Cleanup function: remove event listener when component unmounts
        return () => {
            let service = new Services();
            // window.removeEventListener('resize', updateDimensions);
            service.logService(`Gen Ai Home page successfully unmounted for ${userid.toLowerCase()}`, 'info')
        };
    }, []); // Empty dependency array ensures this effect runs only once on mount

    useEffect(() => {
        try {
            let username = JSON.parse(localStorage.getItem('userdisplayName'));
            if (username) {
                let userNameSplit = username.split(" ");
                if (userNameSplit.length > 1) {
                    let firstName = userNameSplit[0];
                    let lastName = userNameSplit[1];
                    setInitials(`${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`)
                } else {
                    setInitials(`${username[0].toUpperCase()}`)
                }
            }
        } catch (error) {
        }
    }, []);

    const handleAIMode = (query) => {
        props.handleAIMode(query);
        // if (query) {
        //     let data = {
        //         sessionID: uuidv4(),
        //         newQuestion: query,
        //         attachedFiles: [],
        //         threadID: uuidv4(),
        //         selectedFilters: [],
        //         renderfilters: [],
        //         isComprehensive: false,
        //         isGraphThread: false,
        //         selectedGraphType: '',
        //         isImageThread: false,
        //     }
        //     history.push({
        //         pathname: '/genAISearch',
        //         state: data // your data array of objects
        //     })
        // } else {
        //     history.push({
        //         pathname: '/genAIAnswering',
        //     })
        // }
    }


    const handleChangeInSearch = (searchKeyword, appliedFilters) => {
        props.handleChangeInSearch(searchKeyword, appliedFilters);
    }
    if (customWidth < 600) {

        return (<ErrorBoundary>
            {userExists ? <>
                <div className="genAIRecommendedInnerWrapperResult-mobile">
                    <GenAINavigationMenu pathName={window.location.pathname} customWidth={customWidth}
                        customHeight={customHeight} />
                    <div style={{ position: 'relative' }}>
                        <SearchAskQuestionIndex
                            customWidth={customWidth}
                            customHeight={customHeight}
                            searchKeyword={searchKeyword}
                            handleChangeInSearch={handleChangeInSearch}
                            handleAIMode={handleAIMode}
                            appliedFilters={props.appliedFilters}
                            allFilters={props.allFilters}
                            handleClearSearch={props.handleClearSearch}
                            csPath={props.csPath}
                            csproduct={props.csproduct}
                            dropdownValue={dropdownValue}
                            fieldedValue={fieldedValue}
                            isDisableAIOverview={isDisableAIOverview}
                            isDisableAIOverviewProcessing={isDisableAIOverviewProcessing}
                            handleOnClickIsDisableAIOverview={props.handleOnClickIsDisableAIOverview}
                        />
                    </div>
                </div>
            </> :
                <div style={{ textAlign: "center", padding: "10%" }}>
                    <img src={imsLoader} alt="Loading Data" style={{ width: "20%" }} />
                </div>
            }
        </ErrorBoundary>)
    }
    else if (customWidth >= 600 && customWidth < 1000) {
        return (<ErrorBoundary>
            {userExists ? <>
                <div className="genAIRecommendedInnerWrapperResult-tablet">
                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", width: "100%", padding: "0 0px", marginBottom: "0px" }}>

                        <GenAIGlobalMyLinks customWidth={customWidth} customHeight={customHeight} pathName={props.pathName} />


                        <GenAIMyAvatar customWidth={customWidth} customHeight={customHeight} pathName={props.pathName} avatarBg={props.avatarBg} outerAccent={props.outerAccent} />

                    </div>
                    <div style={{ textAlign: "center", marginBottom: "12px" }}>
                        <Link to="/" >  <img src={JJ_IMedical_icon} alt="iMedical Search" height={34} /></Link>
                    </div>
                </div>
                <SearchAskQuestionIndex
                    customWidth={customWidth}
                    customHeight={customHeight}
                    searchKeyword={searchKeyword}
                    handleChangeInSearch={handleChangeInSearch}
                    handleAIMode={handleAIMode}
                    appliedFilters={props.appliedFilters}
                    allFilters={props.allFilters}
                    handleClearSearch={props.handleClearSearch}
                    csPath={props.csPath}
                    csproduct={props.csproduct}
                    dropdownValue={dropdownValue}
                    fieldedValue={fieldedValue}
                    isDisableAIOverview={isDisableAIOverview}
                    isDisableAIOverviewProcessing={isDisableAIOverviewProcessing}
                    handleOnClickIsDisableAIOverview={props.handleOnClickIsDisableAIOverview}
                />
            </> : <div style={{ textAlign: "center", padding: "10%" }}>
                <img src={imsLoader} alt="Loading Data" style={{ width: "20%" }} />
            </div>}
        </ErrorBoundary>)
    }
    else {
        return (<ErrorBoundary>
            {userExists ? <>
                <div className="genAIRecommendedInnerWrapperResult">
                    {/* <div className="genAIRecommended-new-header-wrapper-result">
                        <Link to="/" ><span className="genAIRecommended-header-Content-center">Content Center-AI</span></Link>
                    </div> */}
                    <div className="genAIRecommended-main-ask-question-Imedical-icon" >
                        <Link to="/" >  <img src={JJ_IMedical_icon} alt="iMedical Search" height={34} /></Link>
                    </div>
                    <div>
                        <SearchAskQuestionIndex
                            customWidth={customWidth}
                            customHeight={customHeight}
                            searchKeyword={searchKeyword}
                            handleChangeInSearch={handleChangeInSearch}
                            handleAIMode={handleAIMode}
                            appliedFilters={props.appliedFilters}
                            allFilters={props.allFilters}
                            handleClearSearch={props.handleClearSearch}
                            csPath={props.csPath}
                            csproduct={props.csproduct}
                            dropdownValue={dropdownValue}
                            fieldedValue={fieldedValue}
                            isDisableAIOverview={isDisableAIOverview}
                            isDisableAIOverviewProcessing={isDisableAIOverviewProcessing}
                            handleOnClickIsDisableAIOverview={props.handleOnClickIsDisableAIOverview}
                        />
                    </div>
                    <div className="genAIRecommended-header-myLink-myProfile-wrapper" >
                        <GenAIGlobalMyLinks customWidth={customWidth} customHeight={customHeight} pathName={props.pathName} />
                        <GenAIMyAvatar customWidth={customWidth} customHeight={customHeight} pathName={props.pathName} avatarBg={props.avatarBg} outerAccent={props.outerAccent} />
                    </div>
                </div>
            </> : <div style={{ textAlign: "center", padding: "10%" }}>
                <img src={imsLoader} alt="Loading Data" style={{ width: "20%" }} />
            </div>}
        </ErrorBoundary>)
    }
}

Header.propTypes = {
    avatarBg: PropTypes.string,
    outerAccent: PropTypes.string,
};

Header.defaultProps = {
    avatarBg: "#0F68B2",
    outerAccent: "#8C3BBB",
};